import {
  FetchMediaFileResponse,
  UploadAnonymousMediaFileResponse,
  UploadMediaFileRequest,
  UploadMediaFileResponse,
} from '../types/media';
import { ApiService } from './common/ApiService';

class MediaService extends ApiService {
  pathname = 'media';

  constructor() {
    super(process.env.REACT_APP_BASE_API_URL);
  }

  uploadPrivate = async ({ file, entity }: UploadMediaFileRequest) => {
    const formData = new FormData();
    formData.append('file', file);

    return this.post<UploadMediaFileResponse, FormData>(`${this.pathname}/upload/${entity}/private`, formData);
  };

  uploadPublic = async ({ file, entity }: UploadMediaFileRequest) => {
    const formData = new FormData();
    formData.append('file', file);

    return this.post<UploadMediaFileResponse, FormData>(`${this.pathname}/upload/${entity}/public`, formData);
  };

  getPrivateFile = async (fileName: string) =>
    this.get<FetchMediaFileResponse>(`${this.pathname}/upload/private/${fileName}`);

  getPublicFile = async (fileName: string) =>
    this.get<FetchMediaFileResponse>(`${this.pathname}/upload/public/${fileName}`);

  /** Unauthenticated upload (e.g. fund manager logo). Entity e.g. 'fundManager'. */
  uploadAnonymousPublic = async (file: File, entity: string) => {
    const formData = new FormData();
    formData.append('file', file);
    return this.post<UploadAnonymousMediaFileResponse, FormData>(
      `${this.pathname}/upload/anonymous/${entity}/public`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
  };
}

export const mediaService = new MediaService();
